import React, {memo, useState} from "react";
//local
import SubHeading from "components/SubHeading";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {SmartTemplatesModal} from "components/modals/SmartTemplatesModal";
import {IconCog, IconList} from "components/icons";

const SmartTemplatesSettings = memo(({isAdminOwner}) => {
  const [isSmartTemplatesModal, setSmartTemplatesModal] = useState(false);

  return (
    <>
      <div className="organization-settings mb-12">
        <SubHeading title="SETTINGS_ORGANIZATION_SMART_TEMPLATES" icon={<IconList />} />
        <div className="df-row-center mt-2">
          <ButtonTransparent
            name="SETTINGS_ORGANIZATION_SMART_TEMPLATES_BUTTON"
            icon={<IconCog />}
            noBorder
            small
            addClass="fz-14 pl-0 __rotate-on-hover"
            onClick={() => setSmartTemplatesModal(true)}
          />
        </div>
      </div>
      {isSmartTemplatesModal && (
        <SmartTemplatesModal
          defaultTab={1}
          disabledTabs={[true, false]}
          isAdminOwner={isAdminOwner}
          onClose={() => setSmartTemplatesModal(false)}
        />
      )}
    </>
  );
});
export default SmartTemplatesSettings;
